import { useSelector } from 'react-redux'
import { selectQueryState, selectQueryString } from '~/app/store/locationState'
import { getBreadcrumbs, getIgpType, getIgpLevel } from '~/app/store/config/reducer'
import { mutateQueryStateParamsWithRefinementToAdd, mutateQueryStateParamsWithRefinementToRemove } from '~/app/features/Gallery/hooks/RedirectToL0/utils'
import { getIsL1orL2 } from '~/app/store/config'
import { REFINEMENT_DIMENSION } from '~/shared/constants'
import { getMetadataQueryParams } from '~/app/store/content/utils'

type UseRedirectToL0ReturnValue = (refinementToAdd: State.Refinement[], refinementToRemove: State.Refinement[]) => boolean

export const useRedirectToL0 = (): UseRedirectToL0ReturnValue => {
  const breadcrumbs = useSelector(getBreadcrumbs)
  const queryState = useSelector((state: State.GlobalState) => selectQueryState(state, { isRedirectToL0: true }))
  const isL1orL2 = useSelector(getIsL1orL2)
  const igpLevel = useSelector(getIgpLevel)
  const igpType = useSelector(getIgpType)
  const isIgpTypeCustom = igpType === 'Custom'
  const { keywords: metadataKeywords, attributes: metadataAttributes, categories: metadataCategories } = useSelector(getMetadataQueryParams)

  return (refinementToAdd: State.Refinement[], refinementToRemove: State.Refinement[]): boolean => {
    if (!isL1orL2 && !isIgpTypeCustom) {
      return false
    }

    const breadcrumbsOffset = isIgpTypeCustom || igpLevel === 1 ? -2 : -3
    const igpL0Url = breadcrumbs && breadcrumbs.slice(breadcrumbsOffset)[0]?.url

    const newQueryStateParams = {
      ...queryState.parameters,
      categories: [...queryState.parameters.categories, ...metadataCategories.map(String)],
      keyword: [queryState.parameters.keyword, ...metadataKeywords].join(' '),
      attributes: [...queryState.parameters.attributes, ...Object.values(metadataAttributes).flat()],
    }
    delete newQueryStateParams.page

    if (![...refinementToAdd, ...refinementToRemove].some((element) => element.dimension === REFINEMENT_DIMENSION.CATEGORY)) {
      return false
    }

    mutateQueryStateParamsWithRefinementToAdd(newQueryStateParams, refinementToAdd)
    mutateQueryStateParamsWithRefinementToRemove(newQueryStateParams, refinementToRemove)

    const queryString = selectQueryString(
      {
        parameters: newQueryStateParams,
        replace: false,
      },
      '',
    )

    if (igpL0Url) {
      window.location.href = igpL0Url + queryString
      return true
    }

    return false
  }
}
